<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <div class="right-menu">
    <!-- <span class="top_name" v-show="userType == 'userAdmin' && showChat"  @click="chatShow = true" style="line-height: 50px; float: left; margin-right: 20px; cursor: pointer; color: #606266; font-size: 14px;"><el-badge :value="gridData.length" class="item"><i class="fa fa-bell" aria-hidden="true"></i></el-badge></span> -->

    <span class="top_name" style="line-height: 50px; float: left; margin-right: 20px; cursor: pointer; color: #606266; font-size: 14px;" @click="homeurl()"><i class="fa fa-home"></i> 前台首页</span>
 

    <!-- <el-dropdown class="avatar-container" style="margin-right:10px;" v-if="dtkp == '大厅开票'">
      <div class="avatar-wrapper" @click="dtkpnurl()">
        <span class="top_name">大厅开票</span>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
      <p class="inlineBlock" style="padding:0 20px; cursor: pointer;"><el-tag effect="plain" @click="dtkpnurl()" type="success" size="medium">内  网</el-tag></p>
      <p class="inlineBlock" style="padding:0 20px; cursor: pointer;"><el-tag effect="plain" @click="dtkpwurl()" size="medium">外  网</el-tag></p>
      </el-dropdown-menu>
    </el-dropdown> -->


    <el-dropdown class="avatar-container">
      <div class="avatar-wrapper">
        <!-- <el-image class="user-avatar" :src="avatar">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image> -->
        <el-image class="user-avatar" :src="avatar"></el-image>
        <span class="top_name">{{name}}</span>
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" v-if="source == true" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <router-link class="inlineBlock" to="/ums/editAdmin" v-if="source == true"><el-dropdown-item>账户设置</el-dropdown-item></router-link>
        <el-dropdown-item v-if="source == true" divided>
          <span @click="logout" style="display:block;">退出账户</span>
        </el-dropdown-item>
        <el-dropdown-item v-else divided>
          <span @click="logout_user" style="display:block;">退出账户</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    </div>
    


  </el-menu>


  
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import {fetchList,getKPDZ} from '@/api/user';
import {userCompanyid} from '@/api/company';
import {fetchList as getOrderList} from '@/api/order'
import {returnUserInfo,getInfo, logout_user} from '@/api/login';
import {CustomerService,historyRecord,getUserInfo,onlineUsers,historyViews,RevokeChat,DeleteChat, uploadChatImg, sendChat, onlineList} from '@/api/kefu';
import {formatDate} from '@/utils/date';
import {filePath} from '@/api/config';
import Emotion from '@/components/Emotion/index'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    Emotion
  },
  props: {
      minimize:{ // 最小化
          type:Boolean,
          default:true,
      },
      miniItem:{
          type:Boolean,
          default:false,
      },
      sellerId:{
          type:Number,
          default:0,
      }
      
  },
  data(){
    return {
      dtkpw:null,
      dtkpn:null,
      chatShow: false,
      direction: 'rtl',
      gridData:[],
      userInfo:[], //客服信息
      company_name:null, //当前用户单位名称
      company_phone:null, //当前用户电话
      orderList:[], //当前用户订单列表
      adminName:null,


      minimizes:this.minimize,
      miniItems:this.miniItem,
      webSocketLink:null,
      socketObj:null,
      isOnline:false, // 是否链接上socket
      connect_info:{ // 用户信息，包括聊天好友信息
          user_id:0,
          to_user_id:0,
      }, 

      pageSize:500,
      pageNum:1,
      loading:true,
      loadend:false,
      Num:null,

      onChat:[],
      onChatIndex:0,
      sendMsg:{
          type:'text', // 类型
          message:'', // 内容
      },
      user_info:{}, // 链接成功后获取到的用户信息
      chat_friend:{}, // 好友列表
      onChatMsg:[], //聊天记录
      chatId:null,  //当前记录ID
      chatUserId:null, //当前记录用户ID

      
      filePath:null,
      showDialog: false,
      timeObj:null,
      userType:null, //用户类别
      viewsList:[], //用户浏览记录
      viewsMore:false,

      menuVisible:false, //右键菜单
      chatRecord:false,  //连接成功后显示聊天记录按钮

      chatEmotion:false, //表情框

      showChat:false, //显示消息图标
      source:true, //默认后台用户登陆

    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'name',
      'roles',
      'dtkp'
    ])
  },
      // watch:{
      //    $route(){
      //      this.addViewTags()
      //      this.moveToCurrentTag()
      //    },
      //   menuVisible(value) {
      //     if (value) {
      //       document.body.addEventListener('click', this.closeMenu)
      //     } else {
      //       document.body.removeEventListener('click', this.closeMenu)
      //     }
      //   }
      // },
    filters: {
      formatNull(value) {
        if(value===undefined||value===null||value===''){
          return '暂无';
        }else{
          return value;
        }
      },
      formatCreateTime(time) {
        let date = new Date(time);
        if(time===undefined||time===null||time===''){
          return '暂无';
        }else{
          return formatDate(date, 'yyyy-MM-dd hh:mm:ss');
        }
      },
      formatTime(time) {
        let date = new Date(time);
        if(time===undefined||time===null||time===''){
          return '暂无';
        }else{
          return formatDate(date, 'yyyy-MM-dd');
        }
      },

    },
    created(){
      // this.getKPDZw();
      // this.getKPDZn();
      if(JSON.parse(localStorage.getItem('getInfo'))){
          this.getInfo = JSON.parse(localStorage.getItem('getInfo'));
          this.userType = this.getInfo.type;
      }else{
            this.getInfo();
      }
      // this.getUserInfo();
      // this.getUser_info();
      // this.getOnlineUsers();
      if(localStorage.getItem('filePath')){
          this.filePath = localStorage.getItem('filePath');
      }else{
          this.filepath();
      }
      if(localStorage.getItem('source') == 'reception'){
        //前台
        this.source = false
      }else{
        //后台
        this.source = true
      }
       
      // this.getOnlineList();

      // this.getCustomerService();
      
    },

    methods: {
    // handleEmotion (i) {
    //   this.sendMsg['message'] = i;
    //   this.chatEmotion = false;
    // },
    // 将匹配结果替换表情图片
    // emotion (res) {
    //   let word = res.replace(/\#|\;/gi,'')
    //   const list = ['微笑', '撇嘴', '色', '发呆', '得意', '流泪', '害羞', '闭嘴', '睡', '大哭', '尴尬', '发怒', '调皮', '呲牙', '惊讶', '难过', '酷', '冷汗', '抓狂', '吐', '偷笑', '可爱', '白眼', '傲慢', '饥饿', '困', '惊恐', '流汗', '憨笑', '大兵', '奋斗', '咒骂', '疑问', '嘘', '晕', '折磨', '衰', '骷髅', '敲打', '再见', '擦汗', '抠鼻', '鼓掌', '糗大了', '坏笑', '左哼哼', '右哼哼', '哈欠', '鄙视', '委屈', '快哭了', '阴险', '亲亲', '吓', '可怜', '菜刀', '西瓜', '啤酒', '篮球', '乒乓', '咖啡', '饭', '猪头', '玫瑰', '凋谢', '示爱', '爱心', '心碎', '蛋糕', '闪电', '炸弹', '刀', '足球', '瓢虫', '便便', '月亮', '太阳', '礼物', '拥抱', '强', '弱', '握手', '胜利', '抱拳', '勾引', '拳头', '差劲', '爱你', 'NO', 'OK', '爱情', '飞吻', '跳跳', '发抖', '怄火', '转圈', '磕头', '回头', '跳绳', '挥手', '激动', '街舞', '献吻', '左太极', '右太极']
    //   let index = list.indexOf(word)
    //   return `<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/${index}.gif" align="middle">`   
    // },
    //附件路径
    filepath() {
      filePath({platId:this.$platId}).then(response => {
        this.filePath = response.data[0].config;
      })
    },

    //当前客服信息
    // getUserInfo() {
    //   returnUserInfo({platId:this.$platId}).then(response => {
    //     this.userInfo = response.data;
    //     this.userInfo.loginId = response.data.loginId;
    //     this.userInfo.id = 100000000 + response.data.id;
    //     // this.websocketInit();
        
    //   })
    // },

    //24小时内提交留言用户
    // getOnlineList() {
    //   onlineList({platId:this.$platId}).then(response => {
    //     if(response.code == 200){
    //     //  this.showChat = true
    //      this.gridData = response.data
    //     }else{
    //       this.showChat = false
    //     }
    //   })
    // },

    //所有客服列表
    // getCustomerService() {
    //   CustomerService({platId:this.$platId,status:'3'}).then(res => {
    //     if(res.code == 200){
    //       this.kefuOptions = res.data;
    //         for (let i = 0; i < res.data.length; i++){
    //           if(res.data[i].name == this.adminName){
    //             this.showChat = true;
    //           }else{
    //             // this.showChat = false;
    //           }
    //         }
    //     } 
    //     // console.log(this.showChat);
    //     // console.log(this.userType);
    //   })
    // },

    //获取用户权限
    getInfo(){
      getInfo().then(response => {
        this.userType = response.data.type;
        this.adminName = response.data.username;
        // this.getCustomerService();
      })
    },

    //在线人数  
    // getOnlineUsers(){
    //   onlineUsers().then(response => {
    //     if(response.code == 200){
    //       // this.kfList = response.data.admins; //客服列表
    //       this.gridData = response.data.users; //用户列表
    //     }
    //   })
    // },


    //建立连接
    // websocketInit:function(){
    //     if(typeof(WebSocket) === "undefined"){
    //         alert("您的浏览器不支持socket")
    //     }else{
    //         // 实例化socket
    //         // this.socketObj = new WebSocket('ws://192.168.0.53:8759/websocket/' +this.userInfo.loginId +'/' + this.userInfo.id + '/' + this.user_info.id);
    //         this.socketObj = new WebSocket(this.$WebSocket  + this.userInfo.id + '/' + this.user_info.id);
    //         // console.log(this.socketObj);
    //         // 监听socket连接
    //         this.socketObj.onopen = this.open;
    //         // 监听socket错误信息
    //         this.socketObj.onerror = this.error;
    //         // 监听socket消息
    //         this.socketObj.onmessage = this.getMessage;
    //         //关闭socket
    //         this.socketObj.onclose = this.socketClose;
    //     }
    // },
    // open: function () {
    //     //延迟请求在线用户列表
    //     // this.timeObj = setTimeout(()=>{
    //     //       this.getOnlineUsers()
    //     // },3000);

    //     // // 如果已经链接则不再重复链接
    //     // if(this.socketObj.readyState == 1){
    //     //     this.minimizes = false;
    //     //     return true;
    //     // }

    //     // 如果登录了，且用户ID存在
    //     // this.sendMsg.type = 'bind';
    //     // this.sendMsg.type = 'heartbeat';
    //     // this.sendMsg.message = '';
    //     // let infoStr = JSON.stringify(this.sendMsg);
    //     // this.timeObj = setInterval(()=>{
    //     //     this.get_chat_msg();
    //     // },10000);

    // },
    // error: function () {
    //     //console.log("连接错误")
    // },
    // socketClose: function () {
    //     console.log("socket已经关闭")
    // },
    closeWindow(){
      // this.socketObj.close();
      this.chatShow = false;
    },

    // getMessage: function (msg) {
         
    //     let obj = JSON.parse(msg.data);
    //     if(obj == undefined){
    //         return;
    //     }

    //     switch(obj.type){
    //         // case 'bind': // 绑定用户成功
    //         //     this.isOnline = true;
    //         //     this.minimizes = false;
    //         //     break;
    //         case 'error':
    //             this.$message.error('消息接收失败!');
    //             break;
    //         case 'text': // 文字接收
    //             break;
    //         case 'image': // 图片接收
    //             break;
    //     }

    //     // 只要不是心跳检测，就查询一次好友列表
    //     if(obj.type != 'heartbeat'){
    //         this.getOnlineUsers();
    //     }

    //     // 只要不是就处理到指定位置
    //     // if(obj.type != 'heartbeat'){
    //     //     // 判断如果发送人不是自己则提示音
    //     //     if(obj.user_id != this.user_info.id){
    //     //         let audio = new Audio(this.music);
    //     //         audio.play();
    //     //     }   
            


    //     //     this.onChat.forEach((item,key)=>{

    //     //         // 正在聊天则将聊天记录放入到onChat内
    //     //         // if(item.id == obj.user_id || item.id == obj.to_user_id){
    //     //         //     this.onChat[key].chat_msg.data.push(obj) // 放入

    //     //         //     // 如果消息存在onChat 则要清空未读记录
    //     //         //     if(obj.user_id != this.user_info.id){
    //     //         //         this.clearNoRead(obj.content.user_id,obj.content.to_user_id);
    //     //         //     }
    //     //         // }

    //     //             this.onChat[key].chat_msg.data.push(obj) // 放入

    //     //             // 如果消息存在onChat 则要清空未读记录
    //     //             if(obj.user_id != this.user_info.id){
    //     //                 this.clearNoRead(obj.content.user_id,obj.content.to_user_id);
    //     //             }  



    //     //     });
    //     // }
        
    // },

    // send: function (type) {
    //     // this.sendMsg.type = 'text';
    //     // this.socketObj.send(JSON.stringify(this.sendMsg));
    //     sendChat({user:this.userInfo.id,receive:this.user_info.id,type:'103',message:this.sendMsg.message,platId:this.$platId}).then(res => {
    //       if(res.code == 200){
    //         // this.$message.success(res.message);
    //       }else{
    //         this.$message.error(res.message);
    //       }
    //     });
    //     this.get_chat_msg();
    //     this.sendMsg.message = '';
    //     // this.sendMsg.type = type;

    //     // 发送信息
    //     // this.$post(this.$api.chatChatEvent,{data:this.sendMsg}).then(res=>{
    //     //     if(res.code == 200){
    //     //         this.sendMsg.content.content = '';
    //     //         this.scrollDown();
    //     //     }else{
    //     //         this.$message.error(res.message);
    //     //     }
    //     // });
        
    // },
    // 清空未读信息
    // clearNoRead:function(user_id,to_user_id){
    //     // this.$post(this.$api.chatReadMsg,{user_id:user_id,to_user_id:to_user_id}).then(()=>{});
    // },


    // 滚动条到底部
    scrollDown() {
        this.$nextTick(() => {
            this.$refs['myScrollbar'].wrap.scrollTop = this.$refs['myScrollbar'].wrap.scrollHeight;
        })
    },

    chatsMessage() {
      this.$notify.success({
        title: '消息提醒',
        dangerouslyUseHTMLString: true,
        message: '1.首页专题商品删除，redis没有删除的BUG 2.新增逻辑: 专题商品添加的同时，添加到redis，原来是五分钟自动加入 3.新增逻辑：首页商品按照权重排序 4.{每两分钟添加新活动商品到redis} 接口逻辑，前活动没过期直接改状态，后活动无法自动加入到reids BUG 5.订单使用部分余额后出现问题的bug 6.分类改为倒叙查询,<p style="text-align:right"><a>查看...</a></p></strong>',
        position: 'bottom-right',
        // showClose: false,
        duration:0
      });
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      localStorage.removeItem('getInfo');
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },

    //前台用户退出
    logout_user(){
      localStorage.removeItem('getInfo');
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })

        // logout_user().then(res=>{
        //       localStorage.removeItem('token');
        //       this.$router.push('/login/user_login');
        // });


    },


      //大厅开票外网
      getKPDZw() {
        getKPDZ('1').then(res => {
          if(res.code == 200){
            this.dtkpw = res.data;
          }
        });
      },
      //大厅开票内网
      // getKPDZn() {
      //   getKPDZ('0').then(res => {
      //     if(res.code == 200){
      //       this.dtkpn = res.data;
      //     }
      //   });
      // },
      // dtkpwurl(){
      //   if(this.dtkpw != null){
      //     window.open(this.dtkpw.split("_")[0]+"/Susiness_Web/newaa/start/index.html?"+window.btoa("hzid="+this.dtkpw.split("_")[1]+"="),"_blank");
      //   }
      // },
      // dtkpnurl(){
      //   if(this.dtkpn != null){
      //     window.open(this.dtkpn.split("_")[0]+"/Susiness_Web/newaa/start/index.html?"+window.btoa("hzid="+this.dtkpn.split("_")[1]+"="),"_blank");
      //   }
      // },
      homeurl(){
        window.open('//www.51bencao.net/',"_blank");
      },
      handleViewFile(info){
        if(info != null){
          window.open(info,"_blank");
        }
      },

    //获取当前用户单位信息
    getUser_Company() {
        var id = this.user_info.id;
        this.listLoading = true;
      userCompanyid(id,{platId:this.$platId}).then(response => {
        this.listLoading = false;
        this.company_name = response.data.list[0].name;
        this.getUser_order();
      });
    },

    //根据当前用户单位信息获取订单
    getUser_order() {
        this.listLoading = true;
        getOrderList({
          pageNum: this.pageNum,
          pageSize: '10',
          keyword:this.company_name,
        }).then(response => {
        this.listLoading = false;
        this.orderList = response.data.list;
        this.total = response.data.total;
      });
    },


    //当前用户浏览记录
    getHistoryViews(){
        historyViews({
          userId:this.user_info.id,
          pageNum: this.pageNum,
          pageSize: '20',
        }).then(response => {
        // this.listLoading = false;
        this.viewsList = response.data.list;
        this.total = response.data.total;
      });

    },
    //订单详情
    handleViewAllOrder(index, row){
      //alert(row.id);
      this.$router.push({path:'/oms/orderDetail',query:{orderId:row.id}});
      //this.reload();
    },

    //跳转商品页面
    handleViewAllGoods(index, row){
          let url= this.$weburl +'goods/info/'+ row.goodId;
          // window.location.replace(url);
          window.open(url);
    },

    // 打开聊天框
    onChatHandle:function(info){
      this.user_info.loginId = info.loginId;
      this.user_info.id = info.id;
      this.company_phone = info.phone;
      // 获取聊天记录列表
      this.get_chat_msg();
      this.timeObj = setInterval(()=>{
          this.get_chat_msg();
      },10000);
      this.getUser_Company(); //获取单位
      this.getHistoryViews(); //获取浏览记录
      this.chatRecord = true;  //聊天记录按钮显示
        // 是否正在聊天
        let isOnChat = false;
        this.onChat.forEach(item => {
            if(item.id == info.id){
                isOnChat = true;
            }
        });

        if(!isOnChat){
            this.onChat.push(info);
        }
    },

    //查看聊天记录    
    viewsChatRecord:function(){
       this.$router.push({path:'/chats/chatRecord',query:{userId:this.user_info.id,kefuId:this.userInfo.id,}});
    },

    //打开表情框
    viewsChatEmotion:function(){
      this.chatEmotion = true;
    },

    //上传附件
    // viewsChatUpload:function(option){
    //     let file = option.file;
    //     let formData = new FormData();
    //     formData.append('file', file);
    //     uploadChatImg(formData).then(res=>{
    //       if(res.code == 200){
    //         // this.user.imgfile = this.filePath + res.data;
    //         // this.handleAvatarSuccess;
    //       }else{
    //         this.$message.error(res.message);
    //       }
    //     })
    // },

      httpRequest(option){
        let file = option.file;
        let formData = new FormData();
        formData.append('file', file);
        uploadChatImg(formData).then(res=>{
          if(res.code == 200){
          // this.sendMsg.type = 'image';
          // this.sendMsg.message = res.data;
          // this.socketObj.send(JSON.stringify(this.sendMsg));
          // this.sendMsg.message = '';
        sendChat({user:this.userInfo.id,receive:this.user_info.id,type:'104',message:res.data,platId:this.$platId}).then(res => {
          if(res.code == 200){
            this.$message.success(res.message);
            this.sendMsg.message = '';
          }
        });
          }else{
            this.$message.error(res.message);
          }
        })
        },

      httpRequestFile(option){
        let file = option.file;
        let formData = new FormData();
        formData.append('file', file);
        uploadChatImg(formData).then(res=>{
          if(res.code == 200){
          // this.sendMsg.type = 'file';
          // this.sendMsg.message = res.data;
          // this.socketObj.send(JSON.stringify(this.sendMsg));
          // this.sendMsg.message = '';
          sendChat({user:this.userInfo.id,receive:this.user_info.id,type:'106',message:res.data,platId:this.$platId}).then(res => {
            if(res.code == 200){
              this.$message.success(res.message);
              this.sendMsg.message = '';
            }
          });
          }else{
            this.$message.error(res.message);
          }
        })
        },


    // 获取聊天记录列表
    get_chat_msg(){
        historyRecord(
          {
          // kefuId:this.userInfo.id, //客服ID
          // userId:this.user_info.id, //用户ID
          userId:this.user_info.id,
          kefuId:this.userInfo.id,
          pageSize:this.pageSize,
          pageNum:this.pageNum,
          platId:this.$platId
          }
          ).then(res=>{
            if(res.code == 200){
              this.onChatMsg = res.data.list;
              this.Num = res.data.totalPage;
              // this.clearNoRead(this.user_info.id,item.id); // 将该正在聊天未读标记已读
              this.$forceUpdate();
              this.scrollDown();
              if(this.Num > 1){
                this.viewsMore = true;
              }
            }else{
                this.$message.error('聊天信息加载失败');
            }
        });
    },

      //右键菜单
      handleRightMenu:function(info){
      this.chatId = info.id;
      this.chatUserId = info.userId;
      // if(this.userInfo.id == this.chatUserId){
      //   this.menuVisible = false; // 先把模态框关死，目的是 第二次或者第n次右键鼠标的时候 它默认的是true
      //   this.menuVisible = true; // 显示模态窗口，跳出自定义菜单栏
      // }
        this.menuVisible = false; // 先把模态框关死，目的是 第二次或者第n次右键鼠标的时候 它默认的是true
        this.menuVisible = true; // 显示模态窗口，跳出自定义菜单栏
      // this.$message.error('暂未开通!');

      },

      //关闭按钮
      closeMenu() {
        this.menuVisible = false
      },

      //撤回消息
      handleRecant(info){
        if(this.userInfo.id == this.chatUserId){
          RevokeChat({userId:this.userInfo.id,data:[info.id]}).then(response => {
            if(response.code == 200){
              this.menuVisible = false;
              this.get_chat_msg();
              this.$message.success(response.message);
            }else{
              this.$message.error(response.message);
            }
          })
        }else{
          this.$message.error('只能撤回本人发送的消息!');
        }

      },

      //删除消息
      handleDelete(info){
        // if(this.userInfo.id == this.chatUserId){
        //   DeleteChat({id:[this.chatId]}).then(response => {
        //     if(response.code == 200){
        //       this.menuVisible = false;
        //       this.get_chat_msg();
        //       this.$message.success(response.message);
        //     }else{
        //       this.$message.error(response.message);
        //     }
        //   })
        // }else{
        //   this.$message.error('只能删除本人发送的消息!');
        // }
          DeleteChat({userId:this.userInfo.id,data:[info.id]}).then(response => {
            if(response.code == 200){
              this.menuVisible = false;
              this.get_chat_msg();
              this.$message.success(response.message);
            }else{
              this.$message.error(response.message);
            }
          })

      },

    //滚动加载聊天记录
    loadMore(){	    	
      setTimeout(() => {
        if(this.Num > this.pageNum){
          this.pageNum = this.pageNum + 1;
          this.get_chat_msg();
        }else{
          this.loading = false;
          this.loadend = true;
        }
          }, 500);	    	
    },
        // loadReduce(){
        //   setTimeout(() => {
        //     if(this.Num > this.pageNum && this.pageNum >= 2){
        //       this.pageNum = this.pageNum - 1;
        //       this.get_chat_msg();
        //     }else{
        //       this.loading = false;
        //       this.loadend = true;
        //     }
        //       }, 500);	    	
        // },




        // 关闭窗口
        closeWin:function(info){
            this.onChatIndex = 0;
            if(this.onChat.length<=1){
                return this.onChat = [];
            }
            this.onChat.forEach((item,key)=>{
                if(item.id == info.id){
                    this.onChat.splice(key,1);
                }
            });
        },


  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>

<style>
.right_head_i{
  color:#909399;
}
.cache_flush{
    line-height: 50px;
    float: left;
    margin-right: 20px;
    cursor: pointer;
}
.top_name{
    line-height: 40px;
    float: left;
    margin-right: 20px;
    cursor: pointer;
}
.cache_flush :hover{
  color: #409eff;
}
.avatar-wrapper:hover .top_name {
  color: #409eff;
}
.el-drawer__body {
    padding: 20px;
}
.el-badge__content.is-fixed {
    top: 15px;
}
.list .el-table td, .list .el-table th {
    padding: 0px 0;
}
.el-scrollbar__wrap {
  overflow-x: hidden;
  margin-bottom: 0px !important;
}
</style>
<style lang="scss">
.chat_image{
    max-width: 200px;
    max-height: 200px;
}
.emoji_block{
    height: 170px;
    position: absolute;
    background: #fff;
    top: 150px;
    .el-scrollbar{
        height: 170px;
    }
}
.emoji_class{
    margin-right: 10px;
    padding-top: 10px;
    float: left;
}
.chat_interface{
    border-radius: 3px;
    .chat_interface_left{
        float: left;
        width: 200px;
        background: #409EFF;
        height: 100%;
        border-radius: 3px 0 0 3px;
        cursor: pointer;
        dl{
            padding: 10px 0;
            margin: 0;
            clear: both;
            dt{
                width: 40px;
                height: 40px;
                img{
                    width: 100%;
                    height: 100%;
                }
                float: left;
                margin-right: 15px;
                margin-left: 15px;
            }
            dd{
                overflow: hidden;
                text-overflow: ellipsis;
                color:#999;
                line-height: 40px;
                height: 30px;
                width: 100px;
                float: left;
                margin: 0;
                font-size: 14px;
                font-weight: normal;
            }
            dd.close{
                float: right;
                width: 20px;
                height: 30px;
                margin-right: 5px;
                cursor:pointer;
                display: none;
            }
        }
        dl.active, dl:hover{
            background: rgb(83, 168, 255);
            dd{
                color:#fff;
            }
        }
        dl.active2{
            background: #333;
            opacity: 0.7;
            dd{
                color:#fff;
            }
        }
        dl:nth-child(1).active{
            border-radius: 3px 0 0 0;
        }
        dl:hover dd.close{
            display: block;
            color:#fff;
        }
        dl:after{
            content:'';
            clear:both;
            display: block;
        }
    }
    .chat_interface_right{
        float: left;
        width: 600px;
        border-right: 1px solid #efefef;
        .chat_interface_right_top{
            background: #efefef;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
            border-radius: 0 3px 0 0;
            i{
                float:right;
                margin-right: 15px;
                // margin-top: 12px;
                // color: #efefef;
            }
        }
        .chat_interface_right_content{
            height: 280px;
            padding-bottom: 15px;
            box-sizing: border-box;
            .el-scrollbar{
                height: 265px;
            }
            .chat_interface_msg_item{
                padding: 15px 0 0 15px;
                .chat_interface_msg_avatar{
                    background-color: #efefef;
                    border-radius: 50%;
                    width: 40px;
                    height: 40px;
                    float: left;
                    margin-right: 15px;
                    img{
                        border-radius: 50%;
                        width: 100%;
                        height: 100%;
                    }
                }
                .chat_interface_msg_time{
                    font-size: 12px;
                    margin-top: 10px;
                    color:#666;
                    line-height: 20px;
                    span{
                        float: left;
                        font-size: 14px;
                        color:#333;
                        margin-right: 15px;
                        font-weight: bold;
                    }
                }
                .chat_interface_msg_time:after{
                    content:'';
                    display: block;
                    clear: both;
                }
                .chat_interface_msg{
                    font-size: 12px;
                    line-height: 20px;
                    padding: 5px 8px;
                    background: #efefef;
                    border-radius: 5px;
                    margin-top: 10px;
                    word-wrap:break-word;
                    // display:inline-block;
                    // min-width: 140px;
                    max-width: 400px;
                    height: 100%;
                    margin-left: 52px;
                    cursor: pointer;
                }
            }
            .me{
                .chat_interface_msg_avatar{
                    float: right;
                }
                .chat_interface_msg_time{
                    float: right;
                    span{
                        float: right;
                        margin-left: 20px;
                    }
                }
                .chat_interface_msg{
                    background: #67C23A;
                    color:#fff;
                    float: right;
                    clear:both;
                    margin-right: 65px;
                    // text-align: right;
                }
            }
            .me:after{
                content:'';
                display: block;
                clear: both;
            }
        }
        .chat_interface_right_send{
            .chat_interface_right_send_tool{
                .tool_item{
                    line-height: 18px;
                    // margin-left: 20px;
                    margin-top: 5px;
                    margin-bottom: 5px;
                    padding:4px 6px;
                    float: left;
                    border-radius: 3px;
                    i{
                        font-size: 18px;
                    }
                }
                .tool_item:hover{
                    background: #efefef;
                }
                .other_tool_item{
                    float:left;
                    font-size: 14px;
                    // i{
                    //     margin-right: 10px;
                    // }
                }
            }
            .chat_interface_right_send_tool:after{
                content:'';
                clear: both;
                display: block;
            }
            .chat_interface_right_send_text{
                height: 50px;
                textarea{
                    font-family:'微软雅黑',  Arial, sans-serif;
                    width: 100%;
                    height: 50px;
                    padding: 5px;
                    color:#666;
                    outline: none;
                    border:none;
                    box-sizing: border-box;
                }
            }
            .chat_interface_right_send_text_btn{
              height: 40px;
              margin-top: 8px;
              border-top: 1px solid #efefef;
                button{
                    // background: #fff;
                    // border:1px solid #efefef;
                    border-radius: 3px;
                    float:right;
                    margin-right: 15px;
                    // line-height: 25px;
                    margin-top: 5px;
                    outline: none;
                    cursor:pointer;
                }
                button:nth-child(1){
                    border: none;
                    // background: #333;
                    color:#fff;
                }
                
            }
            border-top: 1px solid #efefef;
        }
    }
    .chat_interface_right_right{
      float: right;
      width: 200px;
      h2{
        background: #efefef;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        border-radius: 0 3px 0 0;
        margin-top: 0;
        font-weight: normal;
        margin-bottom: 0;
      }
      
    }
    width: 1000px;
    height: 460px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    z-index: 9005;
    position: fixed;
    left: 50%;
    top: 50%;
    background: #fff;
    transform: translate(-50%, -50%);    /* 50%为自身尺寸的一半 */
}
.chat_friend_interface_content{
    dl{
        padding: 15px 0 10px 0; 
        dt{
            width: 40px;
            height: 40px;
            display: blcok;
            float: left;
            margin-left: 15px;
            margin-right: 15px;
            img{
                border-radius: 50%;
                width: 100%;
                height: 100%;
            }
        }
        dd{
            float: left;
            width: 165px;
            line-height: 20px;
            height: 20px;
            font-size: 14px;
            display: block;
            position: relative;
            span{
                border-radius: 50%;
                background: #409EFF;
                color:#fff;
                width: 8px;
                height: 8px;
                position: absolute;
                right: 0px;
                z-index: 1001;
                top: -5px;
            }
        }
        dd.friend_new{
            color:#999;
            font-size: 12px;
            line-height: 16px;
            overflow: hidden;
            height: 16px;
            display: block;
        }
    }
    dl:hover{
        // background: #fcfcfc;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }
    dl:after{
        content:'';
        clear: both;
        display: block;
    }
}
.chat_friend_interface_tab{
    ul{
        border-bottom: 1px solid #efefef;
        li{
            float: left;
            width: 50%;
            text-align: center;
            line-height: 40px;
            color:#999;
            position: relative;
            .border_b{
                border-bottom: 1px solid #333;
                display: none;
                width: 80%;
                margin:0 auto;
                margin-bottom: -1px;
            }
        }
        li:hover{
            color: #333;
        }
        li.border_b_show{
            color:#333;
        }
        li.border_b_show .border_b{
            display: block;
        }
        
    }
    ul:after{
        content:'';
        clear: both;
        display: block;
    }
}
.small_chat{
    z-index: 1000;
    color:#409EFF;
    position: fixed;
    right: 40px;
    bottom: 90px;
    i{
        font-size: 50px;
    }
}
.chat_friend_interface{
    z-index: 1000;
    width: 260px;
    height: 520px;
    position: fixed;
    right: 40px;
    bottom: 0;
    background: #fff;
    .chat_friend_interface_head{
        height: 80px;
        background: #333;
        color:#fff;
        .head_top_info{
            span{
                line-height: 50px;
                margin-left: 15px;
                float: left;
                height: 50;
                overflow: hidden;
                
            }
            font{
                float: left;    
                margin-top: 18px;  
                margin-left: 8px;  
            }
            i{
                float: right;
                line-height: 40px;
                margin-right: 10px;
            }
        }
        .head_top_info:after{
            content:'';
            clear: both;
            display: block;
        }
    }
    .chat_friend_interface_head_desc{
        font-size: 12px;
        color:#f4f4f4;
        margin-left: 15px;
    }
}
.red{
    width: 12px;
    height: 12px;
    display: block;
    border-radius: 50%;
    background: #409EFF;
}
.green{
    width: 12px;
    height: 12px;
    display: block;
    border-radius: 50%;
    background: #67C23A;
}
.chat_shodow{
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.chat_handle{
    cursor:pointer;
    float: right;
    margin-right: 5px;
}
.iconfont {
    font-family: "iconfont" !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
@font-face {
  font-family: 'iconfont';  /* project id 1617825 */
  src: url('//at.alicdn.com/t/font_1617825_5wjqc8ogtbk.eot');
  src: url('//at.alicdn.com/t/font_1617825_5wjqc8ogtbk.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_1617825_5wjqc8ogtbk.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_1617825_5wjqc8ogtbk.woff') format('woff'),
  url('//at.alicdn.com/t/font_1617825_5wjqc8ogtbk.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_1617825_5wjqc8ogtbk.svg#iconfont') format('svg');
}

.center{
  text-align: center;
  margin: 0 auto;
  font-size: 12px;
  margin-top: 10px;
  color: #666;
  line-height: 20px;
}
.el-image__error, .el-image__inner, .el-image__placeholder {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.el-icon-picture-outline{
  margin-top: 12px;
  margin-left: 12px;
}
</style>

<style scoped>
/* 右键菜单 */
.menu__item {
	display: block;
	line-height: 20px;
	text-align: center;
	/* margin:10px; */
	cursor: default;
  padding: 0 20px;
  color: #333;
  cursor: pointer;
  width: 100%;
}
.menu__item:hover{
  color: #333;
  background: #eee;
  
}

.menu {
  margin: 0;
  background: #fff;
  z-index: 100;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
  right: 220px;
}

li:hover {
  background-color: #E0E0E2;
  color: white;
}
.link{
  cursor: pointer;
}
.el-table {
    font-size: 13px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue